import { fetchWithTimeout } from './fetchWithTimeout';
import { UserGroup } from './user-group';

export type PageConfig = {
    pageConfigId?: string;
    componentName?: string;
    path?: string;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    userGroups?: UserGroup[];
};

type CreateRequestData = PageConfig & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: PageConfig;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('page-config/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: PageConfig[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('page-config/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = PageConfig & {
    select?: (keyof PageConfig)[];
    relations?: {
        [key in keyof Pick<PageConfig, 'userGroups'>]?: boolean;
    };
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: PageConfig[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('page-config/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = PageConfig & { pageConfigId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: PageConfig;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('page-config/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: PageConfig[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('page-config/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = PageConfig & { pageConfigId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('page-config/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('page-config/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk };
